import React from 'react';
import { SEO } from '../components/SEO';
import { ContactForm } from '../components/ContactForm';
import { SubpageHero } from '../components/SubpageHero';
import { COMPANY } from '../data/company';

export function ContactPage() {
  return (
    <>
      <SEO 
        title="Kontakt" 
        description="Kontakt Altmuligmanden Juelsminde for et uforpligtende tilbud på din håndværker- eller haveopgave i Juelsminde og omegn." 
      />

      {/* Header Banner */}
      <SubpageHero
        badge="Uforpligtende Tilbud & Kontakt"
        title="Kontakt Altmuligmanden"
        subtitle="Kontakt mig i dag for en uforpligtende snak om din opgave – vi finder en løsning, der passer til dine behov og budget."
        breadcrumbs={[
          { label: "Kontakt" }
        ]}
      />

      {/* Main Contact Section */}
      <section className="py-16 bg-sand-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Contact Info Cards */}
            <div className="lg:col-span-5 space-y-6">
              <div className="bg-white p-8 rounded-2xl border border-sand-border shadow-sm space-y-6">
                <h2 className="text-2xl font-bold text-forest border-b border-sand-border pb-3">
                  Direkte kontaktoplysninger
                </h2>

                <p className="text-muted text-sm leading-relaxed">
                  Kontakt mig i dag for en uforpligtende snak om din opgave – vi finder en løsning, der passer til dine behov og sørger for, at arbejdet bliver udført ordentligt og til tiden. 📞📧
                </p>

                <div className="space-y-4 pt-2">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 bg-forest text-white rounded-xl flex items-center justify-center text-lg shrink-0">
                      <i className="fa-solid fa-phone" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs font-bold text-muted uppercase tracking-wider block">Telefon</span>
                      <a 
                        href={`tel:${COMPANY.phone}`}
                        className="text-forest font-bold hover:text-copper transition-colors text-lg whitespace-nowrap"
                      >
                        {COMPANY.phoneFormatted}
                      </a>
                      <p className="text-xs text-muted">Mandag - Lørdag 07.00 - 18.00</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 bg-forest text-white rounded-xl flex items-center justify-center text-lg shrink-0">
                      <i className="fa-solid fa-envelope" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs font-bold text-muted uppercase tracking-wider block">E-mail</span>
                      <a 
                        href={`mailto:${COMPANY.email}`}
                        className="text-forest font-bold hover:text-copper transition-colors text-base whitespace-nowrap"
                      >
                        {COMPANY.email}
                      </a>
                      <p className="text-xs text-muted">Svarer inden for 24 timer</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 bg-forest text-white rounded-xl flex items-center justify-center text-lg shrink-0">
                      <i className="fa-solid fa-location-dot" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs font-bold text-muted uppercase tracking-wider block">Adresse</span>
                      <span className="text-forest font-bold text-base block">{COMPANY.address}</span>
                      <span className="text-xs text-muted">Juelsminde, Hedensted Kommune</span>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 pt-2 border-t border-sand-border">
                    <div className="w-11 h-11 bg-sand text-forest rounded-xl flex items-center justify-center text-lg shrink-0">
                      <i className="fa-solid fa-id-card" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs font-bold text-muted uppercase tracking-wider block">CVR-nummer</span>
                      <span className="text-forest font-bold text-base whitespace-nowrap">{COMPANY.cvr}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Service Areas Card */}
              <div className="bg-forest text-white p-6 rounded-2xl shadow-sm space-y-3">
                <h3 className="font-bold text-white text-base flex items-center gap-2">
                  <i className="fa-solid fa-map-location-dot" aria-hidden="true" />
                  <span>Dækningsområde</span>
                </h3>
                <p className="text-sand/90 text-sm leading-relaxed">
                  Jeg kører gerne ud til private og erhverv i hele Juelsminde samt omegn, herunder Barrit, Stouby, Glud, Klakring, Rårup, As og Hedensted.
                </p>
              </div>
            </div>

            {/* Contact Form Column */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
